export const ORDER_TYPE = Object.freeze({
    AIRPORT: 'airport',
    EVENT_PACKAGE: 'event_package',
    MONTHLY: 'monthly',
    TRANSIENT: 'transient',
});
